import React from "react";
import { TextField, Checkbox } from "material-ui";
import Tooltip from "../Tooltip";
import AbsoluteLabel from "../AbsoluteLabel";

export default ({ state, handleChange }) => {
  return (
    <div className={"sub-option pdb-section"}>
      <div className={"black-label"}>
        Select protein chains to use for calculations:
        <Tooltip
          id={"protein-chains-tooltip"}
          label={"Use: all/first/A/B or comma separated list of chain IDs."}
        />
      </div>
      <TextField
        name={"chains"}
        hintText="all"
        value={state.chains}
        onChange={e => handleChange(e)}
        errorText={state.errors.chains}
      />
      <br />
      <Checkbox
        name={"optimize_protein"}
        checked={state.optimize_protein}
        onCheck={(e, v) => handleChange(e, v)}
        label={
          <AbsoluteLabel>
            Optimize protein structure using pdb2pqr{" "}
            <Tooltip
              id={"protein-optimizie-tooltip"}
              label={
                "Add missing atoms and resolve steric clashes using pdb2pqr."
              }
            />
          </AbsoluteLabel>
        }
        errorText={state.errors.optimize_protein}
        //  iconStyle={{fill: '#5e80bd'}}
      />
      <br />

      <Checkbox
        name={"keep_water"}
        checked={state.keep_water}
        onCheck={(e, v) => handleChange(e, v)}
        label={
          <AbsoluteLabel>
            Keep crystallographic water molecules{" "}
            <Tooltip
              id={"protein-water-tooltip"}
              label={"Keep water oxygen atoms from HETATM PDB section."}
            />
          </AbsoluteLabel>
        }
        errorText={state.errors.keep_water}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/SubmitForm/pdb_section.js